import { tProvidersProps } from '../../../../providers/LayoutProvider/Layout.types';
import { useModalsContext } from '../../../../providers/ModalsProvider/Modals.context';
import { ReSendMessageModal } from '../MessageContainer/components/EventBubble/components/MessageBubble/Modals/ReSendMessageModal/ReSendMessageModal.component';
import { MessageBarContext } from './MessageBar.context';
import useMessageBar from './MessageBar.hook';

export default function MessageBarProvider(props: tProvidersProps) {
  const { children } = props;
  const messageBar = useMessageBar();
  const { showResendModal } = useModalsContext();

  return (
    <MessageBarContext.Provider value={messageBar}>
      {children}
      {showResendModal && <ReSendMessageModal />}
    </MessageBarContext.Provider>
  );
}
